import Overview from './Overview.vue';
import Full from './Full.vue';
import Detail from '@rebuild/materials/shared/report/Detail.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail
};
